module.exports = __webpack_public_path__ + "static/media/ic_admin_active.1e991628.svg";